<template>
  <div class="flex-row d-flex">
    <div @click="onShowReactionDialog" class="d-flex">
      <div v-for="(item, index) in data.types" :key="index" class="mr-1">
        <v-img
          :src="require(`@/assets/svg/reactions/circle/${item.toLowerCase()}.svg`)"
          width="21"
          height="21"
          contain
        />
      </div>
    </div>
    <div class="ml-2">
      <span
        class="url-button"
        v-text="data.count ? data.count : 0"
        v-if="data.count"
        @click="onShowReactionDialog"
      />
    </div>
    <comment-reaction-dialog
        v-if="reactionDialog && postType"
        :_id="_id"
        :dialog="reactionDialog"
        :postType="postType"
        :onCloseDialog="onCloseDialog"
    />
  </div>
</template>
<script>
import CommentReactionDialog from "./CommentReactionDialog.vue";
export default {
  components: { CommentReactionDialog },
  props: {
    data: Object,
    _id: {
      type: String
    },
  },
  data() {
    return {
      reactionDialog: false,
      postType: "",
    };
  },
methods: {
  onShowReactionDialog() {
    // Fallback: default to "event" if type is missing
    const type = this.data.type || "event";
    this.postType = type;
    this.$nextTick(() => {
      this.reactionDialog = true;
    });
  },
  onCloseDialog() {
    this.reactionDialog = false;
  }
},
};
</script>
<style scoped></style>
